import React from 'react';
import SelectStyled from './select.styled';

// Presentational single-select. Receives its full option list, value, and
// onChange from the parent (NR-1464 spec 5.6) - it does not fetch. Search is
// client-side (antd showSearch + filterOption).
const DuesCycleSelector = ({
  value,
  onChange,
  options = [],
  placeholder = 'Select a dues cycle',
  loading = false,
  disabled = false,
}) => {
  const { Option } = SelectStyled;

  return (
    <SelectStyled
      placeholder={placeholder}
      showSearch
      filterOption={(input, option) =>
        String(option?.children ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      value={value || null}
      loading={loading}
      disabled={disabled}
      onChange={selected => onChange(selected || '')}
      dropdownMatchSelectWidth={false}
      allowClear
      style={{ width: '200px' }}
    >
      {options.map(({ value: optionValue, label }) => (
        <Option key={optionValue} value={optionValue}>
          {label}
        </Option>
      ))}
    </SelectStyled>
  );
};

export default DuesCycleSelector;
